// El aviso de que una generación no salió: la card blanca fija abajo (a la derecha en desktop)
// con el ícono rojo, el mensaje y la cruz para cerrarla. Nació adentro de `InterfazV2` (ADR-541:
// el error se seteaba y nunca se dibujaba) y se extrajo para que los modos con pantalla propia,
// como Videos cortos, avisen igual (ADR-2026-10-30-videos-cortos-errores-con-el-aviso-de-la-app-2).
//
// Va portaleada al body: el panel de contenido es `md:fixed` y deja debajo de la sidebar lo que
// se dibuja adentro. Entra y sale con la transición estándar; mientras sale conserva el último
// mensaje, así no se vacía a mitad de la animación.
import { AlertCircle, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAperturaAnimada } from '../../../hooks/useAperturaAnimada';

export const TarjetaDeErrorDeGeneracion: React.FC<{
  /** El mensaje; `null` = cerrada. */
  mensaje: string | null;
  onCerrar: () => void;
}> = ({ mensaje, onCerrar }) => {
  const { montado, visible } = useAperturaAnimada(!!mensaje, 150);
  const [ultimo, setUltimo] = useState(mensaje);
  useEffect(() => {
    if (mensaje) setUltimo(mensaje);
  }, [mensaje]);
  if (!montado || typeof document === 'undefined') return null;

  return createPortal(
    <div
      role="alert"
      className={`fixed inset-x-4 bottom-4 z-[300] transition-[opacity,transform,filter] ease-out md:inset-x-auto md:bottom-6 md:right-6 md:max-w-[420px] ${
        visible ? 'opacity-100 duration-300 motion-safe:translate-y-0 motion-safe:blur-0' : 'opacity-0 duration-150 motion-safe:translate-y-3 motion-safe:blur-[4px]'
      }`}
    >
      <div className="flex items-start gap-3 rounded-2xl bg-white p-4 shadow-2xl ring-1 ring-black/[0.08]">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#DC2626]/10">
          <AlertCircle className="h-4 w-4 text-[#DC2626]" />
        </div>
        {/* min-w-0 + break-words: un token largo sin espacios (ej. un JSON de error) definía el
            ancho mínimo del flex item, estiraba la card más allá del viewport y dejaba la X de
            cerrar fuera de pantalla. */}
        <p className="min-w-0 flex-1 break-words pt-1 text-[13.5px] leading-snug text-brand-black">{mensaje ?? ultimo}</p>
        <button
          type="button"
          onClick={onCerrar}
          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[#3C3C43]/40 transition-colors hover:bg-black/[0.06]"
          aria-label="Cerrar"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>,
    document.body,
  );
};
